import React,{useCallback,useEffect,useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faStar, faUsers, faClock, faPlay, 
  faCheckCircle, faDatabase, faServer, 
  faCloud, faCode, faProjectDiagram,
  faLaptopCode, faCertificate, faBriefcase
} from '@fortawesome/free-solid-svg-icons';
import './HeroSection.css';

const Aws = () => {
    const [showModal, setShowModal] = useState(false);
      const [formCourseName, setFormCourseName] = useState('AWS');
      const [formData, setFormData] = useState({
        fullName: '',
        mobileNumber: '',
        email: '',
      });
    
      const openModal = () => setShowModal(true);
      const closeModal = useCallback(() => {
        setShowModal(false);
        setFormData({ fullName: '', mobileNumber: '', email: '' });
      }, []);
    
      useEffect(() => {
        const handleEsc = (e) => {
          if (e.key === 'Escape') closeModal();
        };
        window.addEventListener('keydown', handleEsc);
        return () => window.removeEventListener('keydown', handleEsc);
      }, [closeModal]);
    
      const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'mobileNumber') {
          const digitsOnly = value.replace(/\D/g, '');
          if (digitsOnly.length <= 10) {
            setFormData(prev => ({ ...prev, [name]: digitsOnly }));
          }
        } else {
          setFormData(prev => ({ ...prev, [name]: value }));
        }
      };
    
      const handleSubmit = async (e) => {
        e.preventDefault();
        const { fullName, mobileNumber, email } = formData;
    
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
        if (!fullName || !emailRegex.test(email) || mobileNumber.length !== 10) {
          alert('Please fill in valid details.');
          return;
        }
    
        try {
          const response = await fetch('https://api.dikshasea.in/api/enrollments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ...formData, course: formCourseName }),
          });
    
          const result = await response.json();
          if (response.ok) {
            alert('Enrollment successful!');
            closeModal();
          } else {
            alert(result.message || 'Submission failed');
          }
        } catch (err) {
          console.error(err);
          alert('Error submitting form');
        }
      };
    
  return (
    <>
      <section className="hero-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <span className="badge bg-primary bg-opacity-10 text-white mb-3">New AWS Certification</span>
              <h1 className="hero-title">
                Master <span className="hero-highlight">AWS Cloud</span>
              </h1>
              <p className="hero-subtitle">
                Become an AWS cloud expert with our comprehensive certification program. 
                Gain hands-on experience with AWS services, architectures, and best practices 
                to design, deploy, and manage cloud solutions.
              </p>
              
              <div className="course-meta">
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faStar} />
                  </div>
                  <div>
                    <div className="fw-bold">4.8/5.0</div>
                    <small className="text-muted">(5,200 reviews)</small>
                  </div>
                </div>
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faUsers} />
                  </div>
                  <div>
                    <div className="fw-bold">25,000+</div>
                    <small className="text-muted">Certified Professionals</small>
                  </div>
                </div>
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faClock} />
                  </div>
                  <div>
                    <div className="fw-bold">90 hours</div>
                    <small className="text-muted">Hands-on Labs</small>
                  </div>
                </div>
              </div>
              
             <button className="btn btn-primary btn-lg px-4" onClick={openModal}>
                  Enroll Now
                </button>
            </div>
            <div className="col-lg-6 mt-5 mt-lg-0">
              <div className="ratio ratio-16x9">
                <img 
                  src="subcourses-images/aws.jpg" 
                  alt="AWS Certification Course" 
                  className="img-fluid rounded-3 shadow"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="container">
        <div className="course-details">
          <div className="course-content">
            {/* About Course */}
            <section className="about-course">
              <h2 className="section-title">About This Certification</h2>
              <p>This comprehensive AWS certification program prepares you for cloud architect and developer roles. You'll gain expertise in core AWS services, security best practices, and cloud solution design patterns used by top enterprises.</p>
              <p>Through real-world scenarios and hands-on labs, you'll build the skills needed to pass AWS certifications and implement professional cloud solutions.</p>
            </section>
            
            {/* Curriculum */}
            <section className="curriculum">
              <h2 className="section-title">Certification Path</h2>
              
              <div className="curriculum-item">
                <h3><FontAwesomeIcon icon={faCloud} className="me-2" /> Module 1: AWS Fundamentals</h3>
                <p>Master core AWS services and cloud concepts</p>
                <div className="topics">
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> AWS Global Infrastructure</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> IAM and Security Fundamentals</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> EC2 and Compute Services</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> S3 and Storage Options</div>
                </div>
              </div>
              
              <div className="curriculum-item">
                <h3><FontAwesomeIcon icon={faServer} className="me-2" /> Module 2: Networking & Security</h3>
                <p>Design secure, scalable cloud networks</p>
                <div className="topics">
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> VPC Architecture</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Route 53 and DNS</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Security Groups & NACLs</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> AWS Shield and WAF</div>
                </div>
              </div>
              
              <div className="curriculum-item">
                <h3><FontAwesomeIcon icon={faDatabase} className="me-2" /> Module 3: Databases & Analytics</h3>
                <p>Implement data solutions on AWS</p>
                <div className="topics">
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> RDS and Aurora</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> DynamoDB and NoSQL</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Redshift Data Warehouse</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> EMR and Analytics</div>
                </div>
              </div>
              
              <div className="curriculum-item">
                <h3><FontAwesomeIcon icon={faCode} className="me-2" /> Module 4: Deployment & Automation</h3>
                <p>Master CI/CD and infrastructure as code</p>
                <div className="topics">
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Elastic Beanstalk</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> CloudFormation</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> CodePipeline/CodeDeploy</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Terraform on AWS</div>
                </div>
              </div>
              
              <div className="curriculum-item">
                <h3><FontAwesomeIcon icon={faProjectDiagram} className="me-2" /> Module 5: Advanced Architectures</h3>
                <p>Design enterprise-grade cloud solutions</p>
                <div className="topics">
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Serverless Applications</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Microservices on AWS</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Multi-AZ/Region Deployments</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Well-Architected Framework</div>
                </div>
              </div>
            </section>
          </div>  
          
          <div className="course-sidebar">
            <div className="info-item">
              <div className="info-icon">
                <FontAwesomeIcon icon={faClock} />
              </div>
              <div className="info-content">
                <h4>Duration</h4>
                <p>3 Months (15-20 hrs/week)</p>
              </div>
            </div>
            
            <div className="info-item">
              <div className="info-icon">
                <FontAwesomeIcon icon={faCertificate} />
              </div>
              <div className="info-content">
                <h4>Certifications</h4>
                <p>AWS Solutions Architect</p>
                <p>AWS Developer Associate</p>
              </div>
            </div>
            
            <div className="info-item">
              <div className="info-icon">
                <FontAwesomeIcon icon={faLaptopCode} />
              </div>
              <div className="info-content">
                <h4>Hands-on Labs</h4>
                <p>50+ Real-world Exercises</p>
              </div>
            </div>
            
            <div className="info-item">
              <div className="info-icon">
                <FontAwesomeIcon icon={faUsers} />
              </div>
              <div className="info-content">
                <h4>Prerequisites</h4>
                <p>Basic Networking Knowledge</p>
                <p>Linux Fundamentals</p>
              </div>
            </div>
            
            <div className="info-item">
              <div className="info-icon">
                <FontAwesomeIcon icon={faBriefcase} />
              </div>
              <div className="info-content">
                <h4>Career Support</h4>
                <p>Resume Preparation</p>
                <p>Interview Coaching</p>
              </div>
            </div>
            
            <button className="btn btn-primary btn-lg px-4" onClick={openModal}>
                  Enroll Now
                </button>
          </div>
        </div>
      </div>
      {/* MODAL */}
      {showModal && (
        <div
          className="modal d-block fade show"
          style={{ background: 'rgba(0,0,0,0.5)' }}
          onClick={(e) => { if (e.target === e.currentTarget) closeModal(); }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content p-4 d-flex flex-column flex-md-row">
              <div className="w-100 w-md-50 mb-3 mb-md-0">
                <img
                  src="/img/enroll.jpg"
                  alt="Enrollment"
                  className="img-fluid h-100"
                  style={{ objectFit: 'cover', width: '100%' }}
                />
              </div>
              <div className="w-100 w-md-50 ps-md-4">
                <h6 className="text-primary">Course:</h6>
                <h4 className="fw-bold">AWS</h4>
                <form onSubmit={handleSubmit} noValidate>
                  <input
                    className="form-control mb-3"
                    type="text"
                    name="fullName"
                    placeholder="Full Name"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    required
                  />
                  <input
                    className="form-control mb-3"
                    type="text"
                    name="mobileNumber"
                    placeholder="Mobile Number"
                    value={formData.mobileNumber}
                    onChange={handleInputChange}
                    required
                    maxLength={10}
                  />
                  <input
                    className="form-control mb-3"
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                  <div className="d-flex justify-content-end">
                    <button type="button" className="btn btn-outline-dark me-2" onClick={closeModal}>
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Aws;